import { Box, Button, Divider, Text, TextButton } from '@wix/design-system';
import React from 'react';
import s from './trafficAdviceWidget.scss';
export const TrafficAdviceWidget = _ref => {
  let {
    data: {
      trafficAdvice
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const suggestMoreStrategiesText = 'Show me other options';
  const [openAdviceState, setOpenAdviceState] = React.useState(new Array(trafficAdvice.length).fill(false));
  const toggleOpenAdvice = (state, index) => {
    const newState = new Array(trafficAdvice.length).fill(false);
    newState[index] = state;
    setOpenAdviceState(newState);
  };
  const onSuggestMoreStrategiesClick = () => {
    onWidgetAction(TRAFFIC_ADVICE_WIDGET, {
      action: 'suggest more',
      value: suggestMoreStrategiesText
    });
    send(suggestMoreStrategiesText);
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, "Choose a way to grow your traffic."), trafficAdvice == null ? void 0 : trafficAdvice.map((item, index) => /*#__PURE__*/React.createElement(TrafficAdviceItem, {
    key: index,
    title: item.title,
    description: item.description,
    send: send,
    onWidgetAction: onWidgetAction,
    open: openAdviceState[index],
    setOpen: state => toggleOpenAdvice(state, index)
  })), /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    onClick: onSuggestMoreStrategiesClick
  }, suggestMoreStrategiesText));
};
const TrafficAdviceItem = _ref2 => {
  let {
    title,
    description,
    send,
    onWidgetAction,
    open,
    setOpen
  } = _ref2;
  const onReadLessMoreClick = e => {
    e.stopPropagation();
    onWidgetAction(TRAFFIC_ADVICE_WIDGET, {
      action: open ? 'read less' : 'read more',
      value: title
    });
    setOpen(!open);
  };
  const onSelectClick = e => {
    e.stopPropagation();
    onWidgetAction(TRAFFIC_ADVICE_WIDGET, {
      action: 'select',
      value: title
    });
    send(title);
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: onReadLessMoreClick
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "12px",
    className: s.adviceContainer,
    borderRadius: "8px",
    border: "1px solid",
    borderColor: "B40"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    marginBottom: "12px",
    gap: "12px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    priority: "secondary",
    onClick: onSelectClick
  }, "Select")), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginTop: "12px",
    gap: "2px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    maxLines: open ? 6 : 3,
    ellipsis: true,
    showTooltip: false
  }, description), /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    onClick: onReadLessMoreClick
  }, open ? 'Read Less' : 'Read More'))));
};
export const TRAFFIC_ADVICE_WIDGET = 'TRAFFIC_ADVICE_WIDGET';
//# sourceMappingURL=trafficAdviceWidget.js.map